import "./QuickRecs.scss";
import CloseIcon from "./images/icons/close.svg?react";
import { IGif } from "@/common/services/types";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { Image } from "@/components";
import { useQuickRecs } from "./hooks/useQuickRecs";

interface IProps {
  gifs: IGif[];
  rel?: string;
  onClose?: () => void;
}

export const QuickRecs = ({ gifs, rel, onClose }: IProps) => {
  const { handleClose, getHandleClick } = useQuickRecs({ onClose });

  return (
    <div className="QuickRecs">
      <div className="QuickRecs-Info">
        <div className="QuickRecs-Text">Videos you might also like:</div>
        <CloseIcon className="QuickRecs-Close" onClick={handleClose} />
      </div>
      <div className="QuickRecs-Gifs">
        { gifs.map((gif, index) => (
          <div className="QuickRecs-Gif" key={`${gif.id}-${index}`}>
            <Link to={routes.watch(gif.id, rel)} onClick={getHandleClick(index + 1)}>
              <Image className="QuickRecs-Image" src={gif.urls.thumbnail} alt={""} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
